import { APIPersonalAutoApplicationForm } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation } from '../utils/helpers';

export const processUnlistedDriversData = (
  applicationData: APIPersonalAutoApplicationForm,
  validation?: Validation,
): BinderSectionData => {
  const driversSummary = applicationData?.drivers_summary;
  const drivers = applicationData?.drivers || [];
  const isOtherPersonsLicensedToDrive =
    driversSummary.is_other_persons_licensed_to_drive;
  const totalDriversOnApplication = drivers.length;
  const validationData = processValidation(validation);
  const totalDriversListed12Months =
    applicationData.unlisted_drivers.length + applicationData.drivers.length;
  return {
    title: 'Unlisted drivers',
    description: 'Check to account for any drivers not listed on application.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      summary: {
        isOtherPersonsLicensedToDrive,
        totalDriversOnApplication,
        totalDriversListed12Months,
      },
    },
  };
};
